import * as React from 'react';

import a11yKeyPress from 'js/lib/a11yKeyPress';

import { Button } from '@coursera/cds-core';
import type { ButtonProps } from '@coursera/cds-core';
import { ThumbsDownFilledIcon, ThumbsDownIcon } from '@coursera/cds-icons';

import withSingleTracked from 'bundles/common/components/withSingleTracked';
import type { ItemType } from 'bundles/content-feedback/constants/ItemTypes';

export type Props = {
  selected: boolean;
  onDeselect: () => void;
  onSelect: () => void;
  itemFeedbackType: ItemType;
};

const TrackedButton = withSingleTracked({ type: 'BUTTON' })<ButtonProps>(Button);

const Dislike: React.FC<Props> = (props) => {
  const { selected, onSelect, onDeselect } = props;
  const handleClick = () => {
    if (selected) {
      onDeselect();
    } else {
      onSelect();
    }
  };

  return (
    <div className="rc-DislikeContent" data-testid="dislike-button">
      {/* The <div> element has a child <button> element that allows keyboard interaction */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div onClick={handleClick} onKeyPress={(event) => a11yKeyPress(event, handleClick)}>
        <TrackedButton
          {...Button.defaultProps}
          size="small"
          variant="ghost"
          aria-pressed={selected}
          trackingName={'short_form_content_dislike_button_' + (!selected ? 'select' : 'unselect')}
        >
          {selected ? <ThumbsDownFilledIcon color="interactive" /> : <ThumbsDownIcon color="interactive" />}
        </TrackedButton>
      </div>
    </div>
  );
};

export default Dislike;
